import React from "react";
import { withStyles } from "@material-ui/core";
import connect from "react-redux/es/connect/connect";
import Icon from '@material-ui/icons/HowToReg'
import {
  URL_REVIEW_PERIOD_PICKER,
  URL_REVIEW_PERIOD_PICKER_FACILITY_ROUTE,
  SEARCH_CONTEXT_TEACHER_SCHEDULE
} from "redux/constants";
import SchedulePicker from './SchedulePicker';
import styles from './styles';
import Grid from "@material-ui/core/Grid"
import WeekView from './WeekView'
import {
  fetchReviewPeriods,
  startCurrentTimelinePoll,
  stopCurrentTimelinePoll,
  resetCurrentTimeline
} from 'redux/admin/Actions'

class ReviewPeriodPicker extends React.Component {
  componentDidMount() {
    if (!this._currentTimelinePollStarted) {
      this.props.startCurrentTimelinePoll()
      this._currentTimelinePollStarted = true
    }
  }

  componentWillUnmount() {
    if (this._currentTimelinePollStarted) {
      this.props.stopCurrentTimelinePoll()
      this.props.resetCurrentTimeline()
      this._currentTimelinePollStarted = false
    }
  }

  handleUpdate = ({ propertyName, val }) => {
    this.setState({ [propertyName]: val });
  };

  render() {
    const { classes, teachers = [], locations = [], weekCalendar } = this.props;

    return (
      <div className={classes.root}>
        <SchedulePicker
          classes={classes}
          teachers={teachers}
          locations={locations}
          handleUpdate={this.handleUpdate}
        />
        <Grid container spacing={16}>
          <WeekView
            show={true}
            weekCalendar={weekCalendar}
            fetchReviewPeriods={this.props.fetchReviewPeriods}
            isTeacherSelected={this.props.selectedTeacher !== null}
            isLocationSelected={this.props.selectedLocation !== null}
            isCourseSelected={this.props.selectedCourse !== null}
            currentTimeline={this.props.currentTimeline}
          />
      </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ...state.admin.attendanceReview,
  currentTimeline: state.admin.currentTimeline
});

const mapDispatchToProps = {
  fetchReviewPeriods,
  startCurrentTimelinePoll,
  stopCurrentTimelinePoll,
  resetCurrentTimeline
};

export const ReviewPeriodPickerPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(ReviewPeriodPicker));

export const reviewPeriodPickerPage = {
  icon: Icon,
  component: ReviewPeriodPickerPage,
  searchContext: SEARCH_CONTEXT_TEACHER_SCHEDULE,
  searchOnPathChange:true,
  name: "Attendance Review",
  displayName: "Attendance Review",
  to: URL_REVIEW_PERIOD_PICKER,
};

export default ReviewPeriodPickerPage;